import React from "react";

import { LocationAlertData } from "../../../../models/LocationAlert";
import { AdminLocationAlertsListRow } from "../Row";

import "./styles.scss";

export interface IAdminLocationAlertItemProps {
  locationAlert: LocationAlertData;
}

export const AdminLocationAlertItem: React.FC<IAdminLocationAlertItemProps> = ({
  locationAlert,
}) => {
  return (
    <div className="admin-location-alert-item">
      <AdminLocationAlertsListRow
        locationAlert={locationAlert}
        isHeader={false}
      />
    </div>
  );
};
